import {
    getBillingProvider,
    listBillingProviders
} from './queries';
import {
    createBillingProvider,
    deleteBillingProvider,
    updateBillingProvider,
    enableBillingProvider,
    disableBillingProvider,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    BillingProvider,
    CreateBillingProvider,
    DeleteBillingProvider,
    GetBillingProvider,
    ListBillingProviders,
    UpdateBillingProvider,
    EnableBillingProvider,
    DisableBillingProvider
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;


const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

export const fetchRecords = async (query: ListRecordsQuery) => {
    const { filter, ...rest } = query;
    const transformedFilter = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListBillingProviders>>({
                                                                                  query: listBillingProviders,
                                                                                  variables: {
                                                                                      ...rest,
                                                                                      ...(Object.keys(transformedFilter).length ? { filter: transformedFilter } : {})
                                                                                  },
                                                                              });


    return {
        items: response.data.listBillingProviders.items,
        nextToken: response.data.listBillingProviders.nextToken
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetBillingProvider>>({
                                                                                query: getBillingProvider,
                                                                                variables: {id: id},
                                                                            });
    return response.data?.getBillingProvider;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateBillingProvider>>({
                                                                                   query: createBillingProvider,
                                                                                   variables: {input: payload},
                                                                               });
    console.debug('in the service response', response);
    return response.data?.createBillingProvider;
};

export const update = async (id: string, record: BillingProvider) => {

    console.debug('IN UPDATE', id, record);

    const {
        created: _created,
        updated: _updated,
        ...rest
    } = record

    const response = await client.graphql<GraphQLQuery<UpdateBillingProvider>>({
                                                                                   query: (updateBillingProvider),
                                                                                   variables: {input: rest},
                                                                               });

    return response.data?.updateBillingProvider;
};

export const enableRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<EnableBillingProvider>>({
        query: enableBillingProvider,
        variables: { id }
    });
    return response.data?.enableBillingProvider;
};

export const disableRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DisableBillingProvider>>({
        query: disableBillingProvider,
        variables: { id }
    });
    return response.data?.disableBillingProvider;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteBillingProvider>>({
                                                                                   query: (deleteBillingProvider),
                                                                                   variables: {input: {id: id}},
                                                                               });
    return response.data?.deleteBillingProvider;
};
